export default __webpack_public_path__ + "static/media/curry_247B66A73F15F.cde361cc.jpg";